import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { checkoutClient, sendRioEvent, SharedCommandNames, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import { AppDevConfigs } from '../../constants/AppConstants';
import { Component } from '../../constants/CallbackConstants';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
import { doFireStatusUpdate, sendRioEventCallback } from '../../utils/CallbackUtils';

/**
 * Set App constants to dev if base url is non prod url
 * @param cheggBaseUrl
 * @param dispatch
 */
export var initializeApp = function initializeApp(cheggBaseUrl, dispatch) {
  if (cheggBaseUrl && cheggBaseUrl.indexOf('chegg.com') == -1) {
    // allows for matching chegg.com and chegg.com/ for production
    // in case of non prooduction url, set app constants as develop
    dispatch(saveConfigs({
      appConstants: AppDevConfigs
    }));
  }
};
export var initializeSDK = function initializeSDK(authorization, rioNamespace) {
  // Initialize checkout sdk by calling authorize
  var initStatus = checkoutClient.authorize(authorization);
  var isSuccessful = initStatus.success;
  if (!isSuccessful) {
    var errors = initStatus.errors;
    doFireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: SharedCommandNames.AUTHORIZE,
      payload: {
        component: Component.APP,
        errors: errors
      }
    }]);
    sendRioEvent({
      info: 'chegg error',
      specType: SpecType.NOTIFICATION,
      subType: SubType.ERROR,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      message_detail: "user authorization error: ".concat(JSON.stringify(errors))
    });
  }
  return isSuccessful;
};

/**
 * gather checkout sdk authorization params
 */
export var getCheckoutSdkAuthParams = function getCheckoutSdkAuthParams(authorization) {
  return _objectSpread(_objectSpread({}, authorization), {}, {
    useBFF: true,
    apiKey: authorization.apiKey,
    cheggBaseUrl: authorization.cheggBaseUrl,
    cheggGraphQLUrl: authorization.cheggGraphQLUrl,
    // setting hard-coded csrfToken, to be deprecated
    csrfToken: 'csrfToken'
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/App/utils.js
// module id = 1494
// module chunks = 11